<template>
  <transition name="zoom">
    <div>
      <el-card v-loading="loading"
               class="page-box detail-box settle"
               shadow="never">
        <div slot="header" class="clearfix">
          <div class="title">订单信息</div>
          <span class="close"  @click="$emit('order-view','order-list')">
          <icon-svg iconClass="close-small"></icon-svg>
        </span>
        </div>
        <div class="order-info">
          <div class="content">
            <div class="content-info">订 单 号：</div>
            <div class="content-info">{{orderForm.orderNo}}</div>
          </div>
          <div class="content">
            <div class="content-info">客户名称：</div>
            <div class="content-info">{{orderForm.name}}</div>
          </div>
          <div class="content">
            <div class="content-info">联系方式：</div>
            <div class="content-info">{{orderForm.phone}}</div>
          </div>
          <div class="content-long">
            <div class="content-info">服务地址：</div>
            <div class="content-info">{{orderForm.addr}}</div>
          </div>
          <div class="content-long">
            <div class="content-info">特殊说明：</div>
            <div class="content-info">{{orderForm.tsRemark}}</div>
          </div>
          <div class="content">
            <div class="content-info">预约时间：</div>
            <div class="content-info">{{orderForm.orderTime}}</div>
          </div>
          <div class="content">
            <div class="content-info">服务价格：</div>
            <div class="content-info">{{orderForm.orderAmount}}</div>
          </div>
          <br/>
          <div class="content">
            <div class="content-info">服务开始时间：</div>
            <div class="content-info">{{orderForm.beginDate}}</div>
          </div>
          <div class="content">
            <div class="content-info">服务截至时间：</div>
            <div class="content-info">{{orderForm.endDate}}</div>
          </div>
        </div>
        <div class="order-info">
          <div class="title">账户余额 </div>
          <div class="user-amount">
            <div class="user-info">
              <div class="user-remaining">客户名称： {{orderForm.name}}</div>
              <div class="user-member">
                <div class="member-left">
                  <div class="member-left-text">剩余金额</div>
                  <div class="member-left-money">{{memberMoney.balance}} <span class="unit">元</span></div>
                </div>
                <div class="member-right">
                  <div class="member-left-text">剩余次数</div>
                  <div class="member-left-money" style="color: #02D0C4">{{memberMoney.surplusNum}}  <span class="unit">元</span></div>
                </div>
              </div>
            </div>
            <div class="user-item">
              <span
                class="service-item"
                v-for="entity in memberContent"
                :key="entity.chargeContentId">
                {{entity.serviceName}} ({{entity.balance}})
              </span>
            </div>
          </div>
        </div>
        <div class="order-info">
          <div class="title-no"> 服务结算项目 </div>
          <el-table
            :data="orderForm.orderDetailList"
            style="width: 100%">
            <el-table-column
              prop="serviceName"
              label="服务名称">
            </el-table-column>
            <el-table-column
              prop="serviceUnitPrice"
              label="服务单价">
            </el-table-column>
            <el-table-column
              prop="servicePrice"
              label="本次服务价格">
            </el-table-column>
            <el-table-column
              prop="offsetFlag"
              label="是否抵扣服务次数">
              <template slot-scope="{row,$index}">
                <el-switch
                  v-model="row.offsetFlag"
                  :disabled="row.disableFlag"
                  @change="switchChange(row)">
                </el-switch>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="total-money">订单总费用： {{ totalMoney }}元</div>
        <div class="close-win">
          <el-button style="width: 120px" @click="$emit('order-view','order-list')">关闭</el-button>
          <el-button type="primary"  style="width: 120px" @click="dialogFormVisible = true">结算</el-button>
        </div>
      </el-card>
      <el-dialog
        v-loading = 'postLoading'
        title="支付确认"
        :visible.sync="dialogFormVisible"
        :modal="false">
        <el-form
          :model="consume"
          ref="consumeForm"
          label-width="180px"
          :rules="rules">
          <el-form-item label="本次服务共消费:">
            <div><span class="money">{{totalMoney}}</span> 元</div>
          </el-form-item>
          <el-form-item label="会员卡抵扣：">
            <div v-for="(entity,index) in members" :key="entity.serviceId">{{index+1}}. {{entity.serviceName}} * {{entity.balance - entity.surplusNum}}</div>
            <div v-if="members.length === 0"> 无 </div>
          </el-form-item>
          <el-form-item label="待支付金额：">
            <div><span class="money">{{offsetAmount}}</span> 元</div>
          </el-form-item>
          <el-form-item label="余额抵扣：" prop="chargeBalance">
            <el-input v-model.number="consume.chargeBalance" autocomplete="off">{{chargeBalance}}</el-input>
          </el-form-item>
          <el-form-item label="实际支付：">
            <el-input v-model="consume.receivedAmount" autocomplete="off" disabled></el-input>
          </el-form-item>
          <el-form-item label="支付方式：">
            <el-select v-model="consume.chargeMode" placeholder="请选择支付方式">
              <el-option
                v-for="entity in chargeModes"
                :label="entity.dictItemDesc"
                :value="entity.dictItemCode"
                :key="entity.dictItemCode">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button style="width: 100px" @click="dialogFormVisible = false">取 消</el-button>
          <el-button style="width: 130px" type="primary" @click="submitForm">确认支付</el-button>
        </div>
      </el-dialog>
    </div>
  </transition>

</template>

<script>
import {order, dict} from '@/api'

export default {
  name: 'OrderSettlement',
  components: {},
  watch: {
    chargeBalance (money) {
      if (parseFloat(money).toString() !== 'NaN') {
        let mon = this.offsetAmount - money
        if (mon < 0) mon = 0
        if (mon > this.offsetAmount) mon = this.offsetAmount
        this.consume.receivedAmount = parseFloat(mon).toFixed(2)
      } else {
        this.consume.receivedAmount = 0
      }
    }
  },
  computed: {
    chargeBalance () { // 触发余额计算
      return this.consume.chargeBalance
    },
    totalMoney: function () { // 合计金额
      let money = 0
      for (let orderForm of this.orderForm.orderDetailList) {
        money += parseFloat(orderForm.servicePrice)
      }
      return money.toFixed(2)
    },
    offsetAmount: function () { // 待支付金额
      let money = (this.totalMoney - this.consume.offsetAmount).toFixed(2)
      this.changeOffsetAmount(money)
      return money
    },

    members: function () { // 会员卡抵扣次数展示
      let members = []
      for (let entity of this.memberContent) {
        if (entity.surplusNum < entity.balance) {
          members.push(entity)
        }
      }
      return members
    }
  },
  data () {
    const checkMoney = (rule, value, callback) => { // 金额验证
      if (isNaN(value)) {
        callback(new Error('请输入数字值'))
      } else {
        if (value < 0) {
          callback(new Error('金额不能小于0'))
        } else if (value > 999999999) {
          callback(new Error('金额太大'))
        } else if (value.toString().length > 12) {
          callback(new Error('数值太长'))
        } else if (value > this.offsetAmount) {
          callback(new Error('余额抵扣不能大于待支付金额'))
        } else if (value > this.memberMoney.balance) {
          callback(new Error('余额抵扣不能大于客户余额'))
        } else {
          callback()
        }
      }
    }
    return {
      param: '',
      postLoading: false,
      rules: {
        chargeBalance: [
          { required: true, message: '请输入抵扣金额', trigger: 'blur' },
          {validator: checkMoney, trigger: 'change'}
        ]
      },
      consume: {
        orgCode: this.$store.state.user.orgCode,
        orderNo: '',
        orderFormId: this.param,
        sysUserId: this.$store.state.user.userId,
        memberId: '',
        orderAmount: 0, // 订单金额
        receivedAmount: 0, // 实收金额
        chargeBalance: 0, // 冲抵会员余额
        offsetAmount: 0, // 会员卡抵扣金额
        chargeMode: '5'
      },
      dialogFormVisible: false,
      tableData: [],
      orderForm: {
        orderDetailList: []
      },
      memberMoney: {},
      memberContent: [], // 服务项目
      loading: false,
      chargeModes: []
    }
  },
  methods: {
    changeEvent (value) {
      this.param = value
      this.getData()
    },
    changeOffsetAmount (offsetAmount) {
      if (this.memberMoney.balance > offsetAmount) this.consume.chargeBalance = offsetAmount
      else this.consume.chargeBalance = this.memberMoney.balance
    },
    submitForm () {
      this.$refs['consumeForm'].validate((valid) => {
        if (valid) {
          this.postForm()
        } else {
          return false
        }
      })
    },
    async postForm () {
      this.postLoading = true
      this.consume.orderNo = this.orderForm.orderNo
      this.consume.orderFormId = this.param
      this.consume.orderAmount = this.totalMoney
      let {code, msg} = await order.updateSettlement({
        consume: this.consume,
        members: this.members
      })
      this.postLoading = false
      if (code !== 0) {
        this.dialogFormVisible = false
        this.$message(msg || '网络错误，请稍后重试')
      } else {
        this.dialogFormVisible = false
        this.$message({
          message: '支付成功！',
          type: 'success'
        })
        this.$emit('order-view', 'order-list', 'flush')
      }
    },
    switchChange (row) {
      this.memberContent.find(enitity => {
        if (enitity.chargeContentId === row.serviceId) {
          if (row.offsetFlag) {
            --enitity.surplusNum
            this.consume.offsetAmount += row.servicePrice
          } else {
            ++enitity.surplusNum
            this.consume.offsetAmount -= row.servicePrice
          }
        }
      })
    },
    disableFlag (row) {
      let result = this.memberContent.find(enitity => {
        if (enitity.chargeContentId === row.serviceId && enitity.surplusNum > 0) {
          --enitity.surplusNum
          enitity.amount = row.servicePrice
          this.consume.offsetAmount += row.servicePrice
          return true
        }
        return false
      })
      return !result
    },
    async getData () {
      this.loading = true
      let {code, data} = await order.getOrderSettlementDetail(this.param)
      this.loading = false
      this.memberContent = data.memberContent
      this.memberMoney = data.memberMoney
      this.consume.offsetAmount = 0
      if (code === 0) {
        for (let i = 0; i < data.orderForm.orderDetailList.length; i++) {
          let result = this.disableFlag(data.orderForm.orderDetailList[i])
          if (result) {
            data.orderForm.orderDetailList[i]['disableFlag'] = result
          } else {
            data.orderForm.orderDetailList[i].offsetFlag = !result
          }
        }
      }
      this.orderForm = data.orderForm
      this.consume['serviceName'] = data.orderForm.serviceName
      this.consume.memberId = data.orderForm.memberId
      let dictData = await dict.getDictList({
        dictTypeCode: 'CHARGE_MODE'
      })
      this.chargeModes = dictData.data
    }

  }
}
</script>

<style lang="scss" scoped>
  .settle {
    min-height: calc(100vh - 200px);
  }
  .money {
    font-size: 24px;
    color: $main-color;
  }
  .el-input {
    width: 240px;
  }
  .page-content {
    min-width: 1000px;
  }
  .el-card {
    /*position: absolute;*/
    top: 20px;
    right: 20px;
    left: 20px;
    z-index: 2;
    margin-bottom: 0;
    background-color: #fff;
    /deep/ .el-card__header {
      padding: 0 0 10px 0;
      .title {
        font-size: 16px;
        font-weight: 500;
      }
    }
    .close {
      margin-top: -30px;
      float: right;
      .svg-icon {
        width: 2em;
        height: 2em;
      }
    }
    /deep/ .el-card__body {
      padding: 0;
    }
    .order-info {
      margin-top: 10px;
      .title {
        margin: 20px 0 10px 0;
        font-size: 16px;
        padding-bottom: 10px;
        border-bottom:1px solid #ebeef5;
      }
      .title-no {
        margin: 20px 0 10px 0;
        font-size: 16px;
        padding-bottom: 10px;
      }
      .content {
        margin: 10px 50px 0 0;
        font-size: 14px;
        color: $info;
        display: inline-block;
        .content-info {
          display: inline;
        }
      }
      .content-long {
        margin: 10px 50px 0 0;
        font-size: 14px;
        color: $info;
        .content-info {
          display: inline;
        }
      }
      .user-amount {
        width: 100%;
        height: 150px;
        .user-info {
          float: left;
          display: inline-block;
          margin-top: 20px;
          border: 1px solid #ebeef5;
          width: 300px;
          height: 110px;
          padding: 10px;
          .user-remaining {
            padding: 8px;
          }
          .member-left-text {
            margin: 8px;
            font-size: 13px;
            color: $info;
          }
          .unit {
            color: $info;
            font-size: 12px;
          }
          .member-left-money {
            margin: 10px 8px;
            font-size: 26px;
          }
          .member-left {
            float: left;
            width: 60%;
          }
          .member-right {
            float: right;
            width: 40%;
          }
        }
        .user-item {
          float: left;
          margin: 40px 20px 20px 20px;
          width: 67%;
          /*display: inline-block;*/
          .service-item {
            display: inline-block;
            color: $sidebar-text;
            border-radius: 6px;
            padding: 6px 24px;
            border: 1px solid #ebeef5;
            margin: 10px;
          }
        }
      }
      .el-table {
        margin-top: 0;
      }
    }
    .close-win {
      text-align: center;
    }
    .total-money {
      margin-top: 10px;
    }
  }

</style>
